import { Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";
import { Reveal } from "./Reveal";

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 sm:py-32 bg-forest relative overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        <Reveal className="max-w-2xl mb-16">
          <p className="text-sm uppercase tracking-[0.3em] text-gold font-semibold mb-4">
            Kind Words
          </p>
          <h2 className="font-display text-cream text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
            Trusted by Homeowners Across the Region
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.name} delay={i * 0.1}>
              <div
                data-testid={`testimonial-${i}`}
                className="glass-dark p-8 lg:p-10 h-full flex flex-col"
              >
                <Quote className="text-gold mb-6" size={34} />
                <div className="flex gap-1 mb-5">
                  {Array.from({ length: 5 }).map((_, s) => (
                    <Star key={s} className="text-gold fill-gold" size={16} />
                  ))}
                </div>
                <p className="text-cream/85 leading-relaxed text-[15px] flex-1">
                  "{t.quote}"
                </p>
                <div className="mt-8 flex items-center gap-4">
                  <img
                    src={`${t.img}?auto=format&fit=crop&w=120&q=80`}
                    alt={t.name}
                    loading="lazy"
                    className="w-12 h-12 rounded-full object-cover border border-gold/40"
                  />
                  <div>
                    <div className="font-display text-cream text-base">{t.name}</div>
                    <div className="text-cream/50 text-sm">{t.role}</div>
                  </div>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
